import React from "react";
import { matchPath } from "react-router-dom";
import { ReactComponent as Icon } from "../files/calendar-icon.svg";

import ISVGIconProps from "../ISVGIconProps";

const CalendarIcon = ({
    fill,
    active = "",
    path = "NO_ADDRESS_PROVIDED",
    style = {},
}: ISVGIconProps) => {
    const match = matchPath(
        {
            path: path,
        },
        window.location.pathname
    );
    return (
        <Icon
            fill={match && path !== "NO_ADDRESS_PROVIDED" ? active : fill}
            style={style}
        />
    );
};

export default CalendarIcon;
